module.exports = __webpack_public_path__ + "img/quit.f675ac8e.svg";